import { useMutation, useQueryClient } from '@tanstack/react-query';
import { vehicleRegistrationKeys } from '../services/queryKeys';
import { changeVehicleRegistration } from '../services/vehicleRegistration';
import type { ChangeRegistrationInput } from '../types/vehicleRegistration.types';

export function useChangeVehicleRegistrationMutation(vehicleId: string) {
    const queryClient = useQueryClient();

    return useMutation({
        mutationFn: (input: ChangeRegistrationInput) => changeVehicleRegistration(vehicleId, input),
        /** The panel and the log go stale. Nothing under agreementKeys does: the agreement
         *  has not changed and its vehicle snapshot is immutable by design. */
        onSuccess: () => {
            void queryClient.invalidateQueries({ queryKey: vehicleRegistrationKeys.detail(vehicleId) });
            void queryClient.invalidateQueries({ queryKey: vehicleRegistrationKeys.amendments(vehicleId) });
        },
    });
}
